import { ConsoleLogger, LogLevels, } from "@plansoft-configuration-renderer/utils";
export const i18nLogger = new ConsoleLogger("i18n", LogLevels.warn);
export function logI18nState(i18n, name) {
    i18nLogger.debug([
        `I18n ${name}`,
        `resolvedLanguage="${i18n.resolvedLanguage}"`,
        `language="${i18n.language}"`,
        `languages=[${i18n.languages}]`,
    ].join(" "));
}
//# sourceMappingURL=logI18nState.js.map